module.exports = __webpack_public_path__ + "img/platform-1-icon.b628bbee.svg";